module.exports = __webpack_public_path__ + "img/contact_us_pic@2x.80611743.png";